import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const EmptyScreenMainBox = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const EmptyScreenTitleTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
}))

export const EmptyScreenSecondaryTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}))
